import { ParamHistorical } from '../../../../../shared/types/param';

export interface RedirectAreaParamsHistoricalProps {
    historical: ParamHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createAt: 'Fecha de creación',
    name: 'Nombre',
    extra: 'Descripción',
    active: 'Estado',
};
